import React from "react";
import PropTypes from "prop-types";

/**
 * SearchInput
 * Input de busca padronizado com ícone de lupa e botão de limpar.
 * 
 * Exemplo:
 *   <SearchInput 
 *       value={search} 
 *       onChange={(e) => setSearch(e.target.value)} 
 *       placeholder="Buscar clientes..."
 *   />
 */
const SearchInput = ({
    value = "",
    onChange,
    onClear,
    placeholder = "Buscar...",
    className = "",
    disabled = false
}) => {
    const handleClear = () => {
        if (onClear) {
            onClear();
        } else if (onChange) {
            onChange({ target: { value: "" } });
        }
    };

    return (
        <div className={`position-relative ${className}`}>
            <i
                className="mdi mdi-magnify position-absolute"
                style={{
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "18px",
                    color: "#adb5bd",
                    pointerEvents: "none"
                }}
            ></i>
            <input
                type="text"
                className="form-control"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                style={{
                    paddingLeft: "38px",
                    paddingRight: value ? "38px" : "12px"
                }}
            />
            {value && (
                <i
                    className="mdi mdi-close-circle position-absolute"
                    style={{
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        color: "#adb5bd",
                        cursor: "pointer"
                    }}
                    onClick={handleClear}
                ></i>
            )}
        </div>
    );
};

SearchInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool
};

export default SearchInput;
